import { Reveal, Overline } from "./Reveal";
import { useLang } from "@/i18n";

export const Manifesto = () => {
  const { t } = useLang();
  const chapters = t("manifesto.chapters");
  return (
    <section className="py-32 lg:py-40" data-testid="manifesto-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal>
          <Overline>{t("manifesto.overline")}</Overline>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight max-w-2xl">{t("manifesto.title")}</h2>
        </Reveal>
        <div className="mt-20 space-y-0">
          {chapters.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.1}>
              <div className="grid grid-cols-1 md:grid-cols-12 gap-6 py-12 border-t border-white/10 group" data-testid={`manifesto-chapter-${c.num}`}>
                <span className="md:col-span-2 font-display text-5xl lg:text-7xl font-bold text-outline group-hover:text-ember transition-colors duration-500"
                  style={{ WebkitTextStroke: undefined }}>
                  {c.num}
                </span>
                <h3 className="md:col-span-3 font-display text-xl sm:text-2xl font-semibold uppercase tracking-wide self-start">{c.title}</h3>
                <p className="md:col-span-7 text-steel-400 leading-relaxed text-base lg:text-lg">{c.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
